import { CacheableDataObject } from './CacheableDataObject';
import { Season } from './Season.jsx';
import { ConnectedField } from 'models/ConnectedField';
import { Request } from 'components/Request';

/**
 * Alias for a Ladder. I created a Ladder file a long time ago and don't want to refactor it.
 */
class GameRoom extends CacheableDataObject {

	static verifyLadderId(ladderId) {
		if(ladderId && !isNumeric(ladderId)) {
			console.log(ladderId);
			throw new Error(`invalid ladderId got ${typeof ladderId}`);
		}
		if(!ladderId) {
			return null;
		}
		return Number.parseInt(ladderId);
	}

	beforeConstruct() {
		this.getCharactersPromise = null;
		this.connected_field_types = [];
	}

	/**
	 * calls getCharacters then returns a promise
	 */
	getCharacter(characterId) {
		return this.getCharacters()
			.then((characters) => {
				if(characters[characterId]) {
					return characters[characterId];
				}
				throw new Error(`Character with id :${characterId} was not found`);
			});
	}

	getCharacters() {
		if(this.getCharactersPromise) {
			return this.getCharactersPromise;
		}

		return this.getCharactersPromise = new Promise((resolve, reject) => {
			if(this.characters) {
				resolve(this.characters);
				this.getCharactersPromise = null;
			}
			else {
				Request.apiv1Get('ladders/characters', { ladder_id: this.id })
					.then((response) => {
						this.update({
							characters: response.characters
						});
						resolve(this.characters);
						// this.getCharactersPromise = null;
					})
					.catch(() => {
						reject();
						this.getCharactersPromise = null;
					});
			}
		});
	}

	getActiveSeason() {
		return this.seasons?.[this.active_season];
	}

	getSeasonUrl(season) {
		return `${siteUrl}/rankings/${this.slug}/${season.id}`;
	}

	// The server's mini_logo follows the ladder logo rule (upload, committed
	// file, or the game's most-played ladder's); the slug path is for ladders
	// loaded without it.
	miniImageUrl() {
		return this.mini_logo || siteUrl + '/images/logos/game-filter-logos/' + this.slug + '-mini.png';
	}

	smallImageUrl() {
		return this.small_image;
	}

}

GameRoom.prototype.dataLocationParsers = {
	id: (ladder, data) => {
		if(!data.id) {
			ladder.id = null;
			return;
		}
		ladder.id = Number.parseInt(data.id);
	},
	ladder: function(object, data) {
		object.ladder = data.ladder;
		console.log('the data', data);
		console.error('should not be having ladder set');
	},
	connected_field_types: function(object, data) {
		object.connected_field_types = [];
		for(let i = 0; i < data.connected_field_types.length; i++) {
			let field = data.connected_field_types[i];
			object.connected_field_types[i] = ConnectedField.retrieve(field, field.type);
		}
	},
	season: function(object, data) {
		if(!object.seasons) {
			object.seasons = {};
		}
		if(data.season.id) {
			object.seasons[data.season.id] = Season.retrieve(data.season);
		}
		else {
			object.seasons['default'] = data.season;
		}
	}
};

export { GameRoom };